function a(t) {
  return this.__data__.get(t);
}
export {
  a as default
};
